// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__cHOom","active":"Chip_active__3ZRHB"};